import { Alert } from 'antd';

import { useAuthSession } from '@/entities/auth/api/hooks';
import { PageSpinner } from '@/shared/ui/PageSpinner';
import { TrainingEmployeeDetail } from '@/pages/Training/EmployeeTrainingCard/EmployeeTrainingCard';

/**
 * US-3.1 / US-3.3: персональная страница обучения и инструктажей.
 * Данные: GET /v1/training/employees/{employeeId}, assignments — зона видимости по роли на бэкенде.
 * Вкладка показывается только если роль получает section `my_training` из GET /v1/training/sections.
 */
export function MyTrainingTab() {
  const { data: auth, isLoading } = useAuthSession();

  if (isLoading) {
    return <PageSpinner />;
  }

  const employeeId = auth?.user.employee_id;
  if (!employeeId) {
    return (
      <Alert
        type="info"
        showIcon
        message="К учётной записи не привязана карточка сотрудника"
        description="Обратитесь к администратору, чтобы связать пользователя с записью в реестре персонала."
      />
    );
  }

  return <TrainingEmployeeDetail employeeId={employeeId} showBack={false} hideProfile />;
}
